import { SAVE_TEST_USER_DETAILS } from "./types";

// Save test user deatils
export const saveTestUserDetails = (data) => (dispatch) => {
  dispatch({
    type: SAVE_TEST_USER_DETAILS,
    payload: data,
  });
};
